import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getCarriersAndServices } from "@tKgpco/Services/WORService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { WORCarrier } from "@tKgpco/Store/Data/WOR/WORCarrierState";

type OnSuccess = {
    onSuccess?: (result: any) => void | any | undefined;
};

type OnError = {
    onError?: (result: any) => void | string | undefined;
};

type Parameters = OnError;

type HandlerType = CustomApiHandler<Parameters, WORCarrier[]>;

export const BeginLoadWORCarriers: HandlerType = props => {
    props.dispatch({ type: "Custom/WORCarriers/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCarriersAndServices();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadWORCarriers: HandlerType = props => {
    props.dispatch({
        type: "Custom/WORCarriers/CompleteLoad",
        carriers: props.apiResult,
    });
};

export const chain = [BeginLoadWORCarriers, RequestDataFromApi, CompleteLoadWORCarriers];

const loadWORCarriers = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadWORCarriers");
export default loadWORCarriers;
